import React, { useEffect, useState } from 'react';
import { familyService, Family } from '../../services/familyService';
import styles from './FamiliesMobile.module.css';
import { PlusOutlined } from '@ant-design/icons';

const FamiliesMobile: React.FC = () => {
  const [families, setFamilies] = useState<Family[]>([]);
  const [loading, setLoading] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [editFamily, setEditFamily] = useState<Family | null>(null);
  const [name, setName] = useState('');

  const fetchFamilies = async () => {
    setLoading(true);
    try {
      const data = await familyService.getFamilies();
      setFamilies(data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFamilies();
  }, []);

  const handleAdd = () => {
    setEditFamily(null);
    setName('');
    setShowDrawer(true);
  };

  const handleEdit = (family: Family) => {
    setEditFamily(family);
    setName(family.name);
    setShowDrawer(true);
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Bạn có chắc muốn xóa gia đình này?')) return;
    await familyService.deleteFamily(id);
    fetchFamilies();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (editFamily) {
      await familyService.updateFamily(editFamily.id, name);
    } else {
      await familyService.addFamily(name);
    }
    setShowDrawer(false);
    fetchFamilies();
  };

  const handleCloseDrawer = () => {
    setShowDrawer(false);
    setEditFamily(null);
    setName('');
  };

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      handleCloseDrawer();
    }
  };

  return (
    <div className={styles['family-mobile-container']}>
      <div className={styles['family-mobile-header']}>
        <button
          onClick={handleAdd}
          className={styles['family-mobile-add-btn']}
          title="Thêm gia đình mới"
          type="button"
        >
          <PlusOutlined />
        </button>
      </div>
      <div className={styles['family-mobile-list']}>
        {loading ? (
          <div className="text-center">Đang tải...</div>
        ) : families.length === 0 ? (
          <div className={styles['family-mobile-empty']}>Chưa có gia đình nào.</div>
        ) : (
          families.map((family) => (
            <div
              key={family.id}
              className={styles['family-mobile-card']}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, fontSize: 16, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{family.name}</div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Tạo lúc: {new Date(family.created_at).toLocaleString()}</div>
              </div>
              <div className={styles['family-mobile-actions']}>
                <button
                  style={{ background: '#e0e7ff', color: '#2563eb', border: 'none', borderRadius: 999, padding: '6px 18px', fontWeight: 500, fontSize: 13, cursor: 'pointer' }}
                  onClick={() => handleEdit(family)}
                  aria-label="Sửa"
                >Sửa</button>
                <button
                  style={{ background: '#fee2e2', color: '#dc2626', border: 'none', borderRadius: 999, padding: '6px 18px', fontWeight: 500, fontSize: 13, cursor: 'pointer' }}
                  onClick={() => handleDelete(family.id)}
                  aria-label="Xóa"
                >Xóa</button>
              </div>
            </div>
          ))
        )}
      </div>
      {/* Drawer Modal */}
      {showDrawer && (
        <div className={styles['family-mobile-drawer-overlay']} onClick={handleOverlayClick}>
          <div className={styles['family-mobile-drawer']}>
            <div className={styles['family-mobile-drawer-header']}>
              <div className={styles['family-mobile-drawer-title']}>
                {editFamily ? 'Sửa tên gia đình' : 'Thêm gia đình mới'}
              </div>
            </div>
            <div className={styles['family-mobile-drawer-content']}>
              <form onSubmit={handleSubmit}>
                <div className={styles['family-mobile-form-group']}>
                  <label className={styles['family-mobile-form-label']}>
                    Tên gia đình
                  </label>
                  <input
                    className={styles['family-mobile-form-input']}
                    placeholder="Nhập tên gia đình"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
                <div className={styles['family-mobile-form-actions']}>
                  <button
                    type="button"
                    className={`${styles['family-mobile-form-btn']} ${styles['family-mobile-form-btn-secondary']}`}
                    onClick={handleCloseDrawer}
                  >
                    Hủy
                  </button>
                  <button
                    type="submit"
                    className={`${styles['family-mobile-form-btn']} ${styles['family-mobile-form-btn-primary']}`}
                  >
                    {editFamily ? 'Cập nhật' : 'Thêm mới'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FamiliesMobile;
